// This icon file is generated automatically.
var PUndoOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M7 .94A6.24 6.24 0 003.14 12.1l-.58.75c-.07.08 0 .2.1.2l2.6-.01c.09 0 .15-.08.13-.15l-.62-2.54a.13.13 0 00-.22-.05l-.64.82a5.1 5.1 0 01-1.53-2 4.96 4.96 0 011.07-5.48 4.98 4.98 0 018.15 1.6 4.96 4.96 0 01-1.08 5.47c-.11.12-.23.23-.36.33a.12.12 0 00-.02.17l.62.8c.04.05.12.06.17.01A6.24 6.24 0 007 .93z", "fill-rule": "nonzero" } }] }, "name": "p-undo", "theme": "outlined" };
export default PUndoOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PUndoOutlined.js
// module id = 3703
// module chunks = 0